import React, { useState, useEffect, Fragment } from "react";

interface FormInputProps {
    label?: string;
    type?: string;
    placeholder?: string;
    name?: string;
    options?: { label: string; value?: string }[];
    rows?: number;
    checkboxLabel?: string; // ✅ Make it optional
}


const FormInput: React.FC<FormInputProps> = ({
    label,
    type = "text",
    placeholder,
    name,
    options = [],
    rows = 5,
    checkboxLabel,
}) => {
    return (
        <div className={`${type !== "checkbox" ? "" : "pb-4"}`}>
            {type !== "checkbox" && label && (
                <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
            )}

            {["text", "email"].includes(type) && (
                <input
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    className="w-full border border-inputBorderColor rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                />
            )}

            {type === "textarea" && (
                <textarea
                    name={name}
                    rows={rows}
                    placeholder={placeholder}
                    className="w-full border border-inputBorderColor rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                ></textarea>
            )}

            {type === "tel" && (
                <div className="flex">
                    <select
                        name={name}
                        className="border border-inputBorderColor rounded-r-none w-16 border-r-0 rounded-r-md rounded-l-md px-2 py-2 text-sm focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                    >
                        {options.map((opt, i) => (
                            <option key={i} value={opt.value || opt.label}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    <input
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        className="w-full pl-0 rounded-l-none border border-inputBorderColor border-l-0 border-l-0 rounded-l-md rounded-r-md px-3 py-2 text-sm focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                    />
                </div>
            )}

            {type === "checkbox" && (
                <label className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        className="w-5 h-5 text-blue-600 bg-gray-100 border-inputBorderColor rounded focus:outline-none focus:ring-0 focus:border-inputBorderColor"
                    />
                    <span className="text-gray-500">
                        {checkboxLabel}{" "}
                        <span className="underline cursor-pointer">privacy policy</span>
                    </span>
                </label>
            )}
        </div>
    );
};

export default FormInput;